import React from 'react';

const MentionsLegales = () => {
  return (
    <main className="min-h-screen">
      <div className="pt-20">
        <section className="section bg-white">
          <div className="container mx-auto max-w-4xl">
            <h1 className="heading-xl mb-8 text-gray-900">Mentions légales</h1>
            
            <div className="prose prose-lg max-w-none">
              <h2 className="heading-lg mt-8 mb-4">Éditeur du site</h2>
              <p className="text-body text-gray-700 mb-4">
                <strong>IL TRULLO</strong><br />
                1 Place du 18 Novembre 1944<br />
                90600 Grandvillars<br />
                France
              </p>
              <p className="text-body text-gray-700 mb-4">
                Téléphone : +33 9 78 80 26 23
              </p>

              <h2 className="heading-lg mt-8 mb-4">Hébergement</h2>
              <p className="text-body text-gray-700 mb-4">
                Ce site est hébergé par Emergent.sh
              </p>

              <h2 className="heading-lg mt-8 mb-4">Propriété intellectuelle</h2>
              <p className="text-body text-gray-700 mb-4">
                L'ensemble de ce site relève de la législation française et internationale sur le droit d'auteur et la propriété intellectuelle. Tous les droits de reproduction sont réservés.
              </p>

              <h2 className="heading-lg mt-8 mb-4">Crédits</h2>
              <p className="text-body text-gray-700 mb-4">
                Site web créé avec Emergent.sh
              </p>
            </div>
          </div>
        </section>
      </div>
    </main>
  );
};

export default MentionsLegales;